export var CheckoutCardThreeDSecureEnum;
(function (CheckoutCardThreeDSecureEnum) {
    CheckoutCardThreeDSecureEnum["THREEDSECURE"] = "3dsecure";
    CheckoutCardThreeDSecureEnum["SECURE_OTP_RESPONSE_OK"] = "ok";
    CheckoutCardThreeDSecureEnum["OTP000"] = "OTP000";
    CheckoutCardThreeDSecureEnum["3DS000"] = "3DS000";
})(CheckoutCardThreeDSecureEnum || (CheckoutCardThreeDSecureEnum = {}));
